import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
export var TreeMouseEventTarget;

(function (TreeMouseEventTarget) {
  TreeMouseEventTarget[TreeMouseEventTarget["Unknown"] = 0] = "Unknown";
  TreeMouseEventTarget[TreeMouseEventTarget["Twistie"] = 1] = "Twistie";
  TreeMouseEventTarget[TreeMouseEventTarget["Element"] = 2] = "Element";
})(TreeMouseEventTarget || (TreeMouseEventTarget = {}));

export var TreeError = /*#__PURE__*/function (_Error) {
  _inherits(TreeError, _Error);

  var _super = _createSuper(TreeError);

  function TreeError(user, message) {
    _classCallCheck(this, TreeError);

    return _super.call(this, "TreeError [".concat(user, "] ").concat(message));
  }

  return TreeError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
export var WeakMapper = /*#__PURE__*/function () {
  function WeakMapper(fn) {
    _classCallCheck(this, WeakMapper);

    this.fn = fn;
    this._map = new WeakMap();
  }

  _createClass(WeakMapper, [{
    key: "map",
    value: function map(key) {
      var result = this._map.get(key);

      if (!result) {
        result = this.fn(key);

        this._map.set(key, result);
      }

      return result;
    }
  }]);

  return WeakMapper;
}();